import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildUrl } from '@tencent/vft-common/url';
import IconShare from '@tencent/vft-component/IconShare';
import env from '@tencent/vft-common/env'; // import { setShare } from '@vip-activity/business/pageSetting'

import { cutStrWithEmoji, parseTemplate } from '@/util';
import { removeHttp } from '@vip-activity/base';
import config from '@/config/index';
import Service from '@/service';
import { img2base64 } from '@tencent/cloud-seal-card/components/vue/v-img-load/helper';
var baseUrl = 'https://m.film.qq.com/vip-activity/kid-cny2021/index.html';
export default {
  name: 'pop-share',
  props: {},
  components: {
    IconShare: IconShare,
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    }
  },
  data: function data() {
    return {
      key: Date.now(),
      base64: '',
      env: env,
      jumpUrl: '',
      base64Icon: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _window$pageSetting;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading.show();

              _context.prev = 1;
              _context.next = 4;
              return _this.getJumpUrl();

            case 4:
              _this.jumpUrl = _context.sent;

            case 5:
              _context.prev = 5;

              _this.loading.hide();

              return _context.finish(5);

            case 8:
              if (!(env.isKidApp && env.isIos)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return img2base64((_window$pageSetting = window.pageSetting) === null || _window$pageSetting === void 0 ? void 0 : _window$pageSetting.分享图);

            case 11:
              _this.base64Icon = _context.sent;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 5, 8]]);
    }))();
  },
  computed: {
    params: function params() {
      return {
        headImg: removeHttp(this.userAvatar || this.defaultAvatar),
        nick: cutStrWithEmoji("".concat(this.userService.nick), 10) || '小宝贝',
        level: this.vipService.vipIcon,
        totalDay: this.红包天数,
        qrUrl: this.jumpUrl
      };
    },

    /**
     * 口令配置信息
     */
    pwdInfo: function pwdInfo() {
      var _window$setting$口令分享;

      return {
        pageId: ((_window$setting$口令分享 = window.setting.口令分享) === null || _window$setting$口令分享 === void 0 ? void 0 : _window$setting$口令分享.口令ID) || '2001',
        jumpUrl: this.actUrl
      };
    },

    /**
     * 带有红包分享信息的活动页url
     */
    actUrl: function actUrl() {
      var params = {
        ptag: 'share_laisee',
        laisee_id: this.todayLaisee
      }; // if (this.urlEnv) params.env = this.urlEnv;

      return buildUrl(baseUrl, params);
    },

    /**
     * 中间页
     */
    middleUrl: function middleUrl() {
      return buildUrl(window.setting.红包中间页, {
        url: this.actUrl
      }, true);
    },
    sealCardId: function sealCardId() {
      return 'Kc5J3hmzIL';
    },
    shareInfo: function shareInfo() {
      var _window$setting$邀请分享, _window$setting$邀请分享2, _window$setting$邀请分享3, _window$setting$邀请分享4;

      return {
        title: parseTemplate((_window$setting$邀请分享 = window.setting.邀请分享) === null || _window$setting$邀请分享 === void 0 ? void 0 : _window$setting$邀请分享.分享标题, {
          user: this.userService
        }),
        link: this.jumpUrl,
        subTitle: parseTemplate((_window$setting$邀请分享2 = window.setting.邀请分享) === null || _window$setting$邀请分享2 === void 0 ? void 0 : _window$setting$邀请分享2.分享描述, {
          user: this.userService
        }),
        singleTitle: parseTemplate((_window$setting$邀请分享3 = window.setting.邀请分享) === null || _window$setting$邀请分享3 === void 0 ? void 0 : _window$setting$邀请分享3.分享朋友圈标题, {
          user: this.userService
        }),
        imageUrl: (_window$setting$邀请分享4 = window.setting.邀请分享) === null || _window$setting$邀请分享4 === void 0 ? void 0 : _window$setting$邀请分享4.分享图,
        kidBase64: env.isKidApp && env.isIos ? this.base64Icon || config.iconBase64 : ''
      };
    }
  },
  methods: {
    success: function success(img) {
      if (!env.isKidApp) {
        this.base64 = img;
      } // this.base64 = img


      console.log('card img success.', Date.now() - this.key, img.length);
    },

    /**
     * 将中间页转为短链
     */
    getShortMiddleUrl: function getShortMiddleUrl() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Service.getShortUrl(_this2.middleUrl);

              case 3:
                res = _context2.sent;
                return _context2.abrupt("return", res.short_url || _this2.middleUrl);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

                _this2.toast('生成短链出了点小问题，请稍后再试');

              case 11:
                return _context2.abrupt("return", _this2.middleUrl);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },

    /**
     * 获取活动页的口令码
     */
    getPassword: function getPassword() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var password;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return Service.getPassword(_this3.actUrl);

              case 3:
                password = _context3.sent;
                return _context3.abrupt("return", "$".concat(password.cmdid, "$"));

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                console.error(_context3.t0);

                _this3.toast('生成口令出了点小问题，请稍后再试');

              case 11:
                return _context3.abrupt("return", '');

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },

    /**
     * 获取二维码跳转链接
     * 口令途径只会使用口令部分，故口令使用携带红包信息的活动页
     * 扫码途径只会使用链接部分，故链接使用中间页短链
     */
    getJumpUrl: function getJumpUrl() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var shortMiddleUrl, password;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.getShortMiddleUrl();

              case 2:
                shortMiddleUrl = _context4.sent;
                console.debug('shortMiddleUrl', shortMiddleUrl); // 获取活动页口令

                _context4.next = 6;
                return _this4.getPassword();

              case 6:
                password = _context4.sent;
                console.debug('password', password);

                if (!password) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", buildUrl(shortMiddleUrl, {
                  code: password
                }));

              case 10:
                return _context4.abrupt("return", shortMiddleUrl);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};